export const ADD_ANOTHER_LABEL_TEXT = "Add another label group";
